import jssVariables from "../../jss_setup";

export const landingPageSplashStyles = {
  headerContainer: {
    smallscreen: {
      display: "grid",
      gridGap: `calc(${jssVariables.normal_gap} * 2.5)`,
      width: "50rem",
    },
  },
  header: {
    fontSize: "large",
    lineHeight: jssVariables.double_gap,
    smallscreen: {
      fontSize: "xx-large",
      lineHeight: `calc(${jssVariables.normal_gap} * 3)`,
    },
  },
  subheader: {
    fontSize: "medium",
    fontWeight: 400,
    lineHeight: jssVariables.double_gap,
    display: "none",
    smallscreen: {
      display: "block",
      fontSize: "large",
      fontWeight: 500,
    },
  },
};

export const lpMainSearchFormStyles = {
  SearchFormNavBar: {
    padding: [jssVariables.normal_gap, 0],
    paddingTop: jssVariables.half_gap,
    paddingBottom: jssVariables.half_gap,
    smallscreen: {
      paddingLeft: 0,
      paddingBottom: 0,
    },
  },
  SearchFormNavBarContainer: {
    gridGap: 0,
    smallscreen: {
      paddingLeft: 0,
      paddingBottom: jssVariables.normal_gap,
    },
  },
  checkbox: {
    checkedColor: jssVariables.colors.secondary_color,
  },
};

export const GeneralCards = {
  header: {
    fontSize: "x-large",
    color: jssVariables.colors.base_color,
    smallscreen: {
      fontSize: "xx-large",
    },
  },
};

export const lpFlightsSearchFormStyles = {
  flightsSearchForm: {
    paddingTop: jssVariables.normal_gap,
  },
};
